import { Controller, useFormContext } from "react-hook-form"
import { GeneralAssetType } from "../utils"
import { useContext, useEffect, useRef, useState } from "react";
import { FormDataContext } from "../context";

export function PictureSection() {

    const { dataAsset } = useContext(FormDataContext)

    const { REACT_APP_BASE_URL_API } = process.env;

    const { control } = useFormContext<GeneralAssetType>()
    const [preview, setPreview] = useState<string>("https://t4.ftcdn.net/jpg/05/17/53/57/360_F_517535712_q7f9QC9X6TQxWi6xYZZbMmw5cnLMr279.jpg");
    const fileInputRef = useRef<HTMLInputElement | null>(null);

    useEffect(() => {
        if (dataAsset?.asset_foto) {
            setPreview(`${REACT_APP_BASE_URL_API}/getimage/?imgpath=${dataAsset.asset_foto}`);
        } else {
            setPreview(preview);
        }
        // eslint-disable-next-line
    }, [dataAsset?.asset_foto]);
    

    return (
        <>
            <div>
                <div className="avatar flex justify-center mt-6 mb-10">
                    <div className="w-[150px]" onClick={() => fileInputRef.current?.click()}>
                        <img 
                            src={preview}
                            alt="" 
                        />
                    </div>
                </div>

                {/* FOTO */}
                <Controller
                    control={control}
                    name="asset_foto"
                    render={({ field }) => (
                        <input
                            ref={fileInputRef}
                            className="absolute mt-[-190px] ml-[100px] w-[150px] h-[150px] rounded-[50%] opacity-0"
                            type="file"
                            accept="image/*"
                            onChange={(e) => {
                                const file = e.target.files?.[0];
                                if (file) {
                                    setPreview(URL.createObjectURL(file));
                                }
                                field.onChange(file);
                            }}
                        />
                    )}
                />
            </div>
        </>
    )
}